import { toast } from 'react-toastify'
const notification = (msg, status = 'info', options = {}) => {
  toast[status](msg, options)
}

const httpNotification = (status, verb, msg, options = {}) => {
  const resp = {
    error: 'Erro',
    success: 'Sucesso'
  }
  notification(msg || `${resp[status]} ao ${verb}`, status, options)
}

export { notification, httpNotification }
